import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";
import { default as LinkComponent } from "@/features/shared/components/link/link";

const Link = ({
  id,
  title,
  data,
  configuration,
}: {
  id: string;
  title?: string;
  data: { url: string };
  configuration: { description?: string };
}) => {
  useRefetchWidget(id);

  return (
    <LinkComponent
      config={configuration}
      name={title ?? ""}
      href={data.url}
      showTitle={false}
    />
  );
};

export default Link;
